'use client'
import {
  firebaseGetLessonsByTopicId,
  firebaseGetSchemaSubcollection,
  firebaseGetSingleDocFromDb,
  getBookedCourse,
} from '@/firebase/utils'
import { addCourseToPurchases } from '@/firebase/courses'
import '@/styles/pagination.scss'
import { selectAllContent } from '@/redux/slices/navigation'

const useCreateBookedCourse = async (
  user,
  router,
  dispatch,
  courseId,
  topicId,
  lessonId,
) => {
  const goToLesson = (theme, module, topic, lesson, courseID, bookedId) => {
    const isAdmin = user?.role === 'admin'
    if (!user || !courseID || (!bookedId && !isAdmin)) {
      return null
    }

    dispatch(
      selectAllContent({
        theme: theme,
        module: module,
        topic: topic,
        lesson: lesson,
        previousSelection: {
          theme: theme,
          module: module,
          topic: topic,
          lesson: lesson,
        },
      }),
    )
    if (isAdmin) {
      router.push(`/admin/courses/learn/${courseID}?custome=${true}`)
    } else {
      router.push(`/student/${courseID}?bookedId=${bookedId}&custome=${true}`)
    }
  }
  const findTopicById = (items, topicID) => {
    for (const theme of items) {
      for (const m of theme.children) {
        const topic = m.children.find((topic) => topic?.id === topicID)
        if (topic) {
          return { theme, module: m, topic }
        }
      }
    }

    return null
  }
  const findFirstTopicHasLesson = async (courseId, items) => {
    for (const theme of items) {
      for (const m of theme.children) {
        for (const topic of m.children) {
          const hasLesson = await firebaseGetLessonsByTopicId(
            courseId,
            topic.id,
          )
          if (hasLesson) {
            return { theme, module: m, topic }
          }
        }
      }
    }

    return null
  }

  const addOrGetBookedCourseDetails = async (course) => {
    try {
      const { courseId } = course
      const response = await getBookedCourse(courseId, user.uid)
      const schema = await firebaseGetSchemaSubcollection(courseId)
      const elements = await findFirstTopicHasLesson(courseId, schema)

      if (!elements || !elements?.topic?.id) {
        router.push('/student/courses')

        return null
      }

      const { theme, module, topic } = elements
      const lessons = await firebaseGetLessonsByTopicId(courseId, topic.id)

      if (response.length > 0) {
        goToLesson(
          theme,
          module,
          { ...topic, children: lessons },
          { id: lessons[0]?.id },
          courseId,
          response[0].mainCourseId,
        )
      } else {
        const ID = await addCourseToPurchases({
          userId: user.uid,
          courseId,
        })
        goToLesson(
          theme,
          module,
          { ...topic, children: lessons },
          { id: lessons[0]?.id },
          courseId,
          ID,
        )
      }
    } catch (err) {
      console.error(err)
    }
  }

  const addOrGetBookedCourseDetailsFromTopic = async (
    course,
    topicId,
    lessonId,
  ) => {
    try {
      const { courseId } = course
      const response = await getBookedCourse(courseId, user.uid)
      const schema = await firebaseGetSchemaSubcollection(courseId)

      const elements = findTopicById(schema, topicId)
      if (!elements || !elements?.topic) {
        router.push('/student/courses')

        return null
      }
      const { theme, module, topic } = elements
      const lessons = await firebaseGetLessonsByTopicId(courseId, topicId)

      if (response.length > 0) {
        goToLesson(
          theme,
          module,
          { ...topic, children: lessons },
          { id: lessonId ? lessonId : lessons[0]?.id },
          courseId,
          response[0].mainCourseId,
        )
      } else {
        const ID = await addCourseToPurchases({
          userId: user.uid,
          courseId,
        })
        goToLesson(
          theme,
          module,
          { ...topic, children: lessons },
          { id: lessons[0]?.id },
          courseId,
          ID,
        )
      }
    } catch (err) {
      console.error(err)
    }
  }
  if (courseId) {
    const res = await firebaseGetSingleDocFromDb('courses', courseId)
    const courseData = { ...res, courseId }
    if (courseId && topicId && lessonId) {
      if (res?.type === 'free') {
        addOrGetBookedCourseDetailsFromTopic(courseData, topicId, lessonId)
      } else {
        router.push(
          `/pricing?courseId=${courseId}&topicId=${topicId}&lessonId=${lessonId}`,
        )
      }
    } else if (courseId && topicId) {
      if (res?.type === 'free') {
        addOrGetBookedCourseDetailsFromTopic(courseData, topicId)
      } else {
        router.push(`/pricing?courseId=${courseId}&topicId=${topicId}`)
      }
    } else if (courseId) {
      console.log(courseId, res, 'res****')
      if (res?.type === 'free') {
        addOrGetBookedCourseDetails(courseData)
      } else {
        router.push(`/pricing?courseId=${courseId}`)
      }
    }
  }
}

export default useCreateBookedCourse
